export default "__VITE_ASSET__CLZpEMuA__"